import React from "react";
import {
    Container,
    Box,
    Typography,
    Grid,
    Paper,
    Card,
    CardContent,
    Button,
    Chip,
    Stack,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheckToSlot,
    faArrowRight,
    faQuoteLeft,
    faUserTie,
    faCity,
    faHandshake,
    faVideo,
    faFilePdf, faBullhorn, faCalendarDays, faClock, faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faXTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

// @ts-ignore
import candidatePhoto from "../assets/images/others/jpg-4.jpg";
import { tracts2026 } from "../data";
// @ts-ignore
import listPhoto from "../assets/images/others/photo-vld-groupe.jpeg";

export default function Home2() {
    return (
        <Box sx={{ bgcolor: "#fcfcfc", minHeight: "100vh", pb: 8 }}>

            <Container maxWidth="lg">
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Paper
                        elevation={0}
                        sx={{
                            mt: 4,
                            width: "100%",
                            borderRadius: 4,
                            overflow: "hidden",
                            border: "1px solid rgba(25, 118, 210, 0.15)",
                            background:
                                "linear-gradient(135deg, rgba(13,71,161,0.06) 0%, rgba(25,118,210,0.03) 50%, rgba(239,108,0,0.05) 100%)",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                            mb: 4
                        }}
                    >
                        <Grid container alignItems="stretch">
                        {/* Texte */}
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Box
                                sx={{
                                    p: { xs: 3, md: 4 },
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
                                    <Box
                                        sx={{
                                            width: 42,
                                            height: 42,
                                            borderRadius: 2,
                                            display: "grid",
                                            placeItems: "center",
                                            bgcolor: "rgba(239,108,0,0.12)",
                                            color: "#ef6c00",
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faBullhorn} />
                                    </Box>

                                    <Chip
                                        icon={<FontAwesomeIcon icon={faCheckToSlot} style={{ color: "#1565c0" }} />}
                                        label="À noter dans vos agendas"
                                        sx={{
                                            bgcolor: "rgba(21,101,192,0.08)",
                                            color: "#1565c0",
                                            fontWeight: 800,
                                            px: 0.5,
                                            borderRadius: 3,
                                        }}
                                    />
                                </Stack>
                                <Typography variant="h5" fontWeight={900} color="#0d47a1" sx={{ mb: 1 }}>
                                    Invitation à la 4ème réunion publique
                                </Typography>
                                <Typography variant="h6" fontWeight={700} color="#1565c0" sx={{ mb: 1 }}>
                                    Jeudi 19 mars 2026 à 20h
                                </Typography>

                                <Typography variant="body1" color="text.secondary" sx={{ mb: 1, maxWidth: 620, lineHeight: 1.7 }}>
                                    Retrouvez <b>Jean-Philippe Guibert</b> et l’équipe <b>Vivre la Démocratie</b> pour la 4ème réunion publique.
                                </Typography>

                                <Stack
                                    direction={{ xs: "column" }}
                                    spacing={1.2}
                                    sx={{
                                        mt: 2,
                                        pt: 2,
                                        borderTop: "1px dashed rgba(0,0,0,0.12)",
                                    }}
                                >
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Box sx={{ color: "#1565c0" }}>
                                            <FontAwesomeIcon icon={faCalendarDays} />
                                        </Box>
                                        <Typography variant="body2" fontWeight={800} color="#37474f">
                                            Jeu. 19 mars 2026
                                        </Typography>
                                    </Stack>

                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Box sx={{ color: "#1565c0" }}>
                                            <FontAwesomeIcon icon={faClock} />
                                        </Box>
                                        <Typography variant="body2" fontWeight={800} color="#37474f">
                                            20h
                                        </Typography>
                                    </Stack>

                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Box sx={{ color: "#1565c0" }}>
                                            <FontAwesomeIcon icon={faLocationDot} />
                                        </Box>
                                        <Typography variant="body2" fontWeight={800} color="#37474f">
                                            Préau de l'école Olivier Métra
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Box>
                        </Grid>

                        {/* Photo */}
                        <Grid size={{ xs: 12, md: 5 }}>
                            <Box
                                sx={{
                                    position: "relative",
                                    height: { xs: 220, md: "100%" },
                                    minHeight: { md: 260 },
                                    bgcolor: "#0d47a1",
                                    overflow: "hidden",
                                }}
                            >
                                <img
                                    src={listPhoto}
                                    alt="Photo de l’équipe"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        display: "block",
                                    }}
                                />

                                {/* Overlay dégradé + badge */}
                                <Box
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        background:
                                            "linear-gradient(90deg, rgba(13,71,161,0.15) 0%, rgba(13,71,161,0.05) 40%, rgba(0,0,0,0.15) 100%)",
                                    }}
                                />
                                <Box
                                    sx={{
                                        position: "absolute",
                                        bottom: 14,
                                        left: 14,
                                        bgcolor: "rgba(255,255,255,0.92)",
                                        border: "1px solid rgba(255,255,255,0.6)",
                                        px: 1.5,
                                        py: 0.8,
                                        borderRadius: 3,
                                        backdropFilter: "blur(6px)",
                                        boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
                                    }}
                                >
                                    <Typography variant="caption" fontWeight={900} color="#0d47a1" sx={{ letterSpacing: 0.6 }}>
                                        L’équipe Vivre la Démocratie
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        </Grid>
                    </Paper>
                </Box>
            </Container>

            {/* --- HERO SECTION --- */}
            <Box
                sx={{
                    bgcolor: "#1565c0",
                    color: "white",
                    py: 6,
                    mb: 6,
                    background: "linear-gradient(135deg, #0d47a1 0%, #1976d2 100%)",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                }}
            >
                <Container maxWidth="lg">
                    <Grid container spacing={4} alignItems="center">
                        <Grid size={{ xs: 12, md: 8 }}>
                            <Chip
                                icon={<FontAwesomeIcon icon={faCheckToSlot} style={{ color: "#fff" }} />}
                                label="Élections Municipales 2026"
                                sx={{ bgcolor: "rgba(255,255,255,0.2)", color: "white", mb: 2, fontWeight: 600 }}
                            />
                            <Typography variant="h3" component="h1" fontWeight={800} gutterBottom>
                                Vivre la démocratie
                            </Typography>
                            <Typography variant="h5" fontWeight={400} sx={{ opacity: 0.9 }}>
                                Une liste citoyenne guidée par Jean-Philippe Guibert pour Bois-le-Roi.
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Container maxWidth="lg">
                <Box sx={{ mb: 5 }}>
                    <Grid container spacing={1.5} alignItems="stretch" sx={{ pb: 5}}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: { xs: 1.5, md: 2 },
                                    borderRadius: 3,
                                    border: "1px solid rgba(21,101,192,0.2)",
                                    bgcolor: "rgba(21,101,192,0.04)",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Grid container spacing={1.5} alignItems="center" sx={{ width: "100%" }}>
                                    <Grid size={{ xs: 12, sm: 8 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, minWidth: 0 }}>
                                            <Box
                                                sx={{
                                                    width: 34,
                                                    height: 34,
                                                    borderRadius: "50%",
                                                    display: "grid",
                                                    placeItems: "center",
                                                    bgcolor: "rgba(21,101,192,0.14)",
                                                    color: "#1565c0",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faArrowRight} />
                                            </Box>
                                            <Typography variant="body1" color="#234" fontWeight={600} sx={{ lineHeight: 1.35 }}>
                                                Consulter la page programme VLD 2026
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 4 }}>
                                        <Box sx={{ display: "flex", justifyContent: { xs: "flex-start", sm: "flex-end" } }}>
                                            <Button
                                                component={Link}
                                                to="/vld-2026/programme"
                                                size="small"
                                                variant="contained"
                                                color="primary"
                                                sx={{ textTransform: "none", borderRadius: 2, fontWeight: 700 }}
                                            >
                                                Voir le programme
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: { xs: 1.5, md: 2 },
                                    borderRadius: 3,
                                    border: "1px solid rgba(21,101,192,0.2)",
                                    bgcolor: "rgba(21,101,192,0.04)",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <Grid container spacing={1.5} alignItems="center" sx={{ width: "100%" }}>
                                    <Grid size={{ xs: 12, sm: 8 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, minWidth: 0 }}>
                                            <Box
                                                sx={{
                                                    width: 34,
                                                    height: 34,
                                                    borderRadius: "50%",
                                                    display: "grid",
                                                    placeItems: "center",
                                                    bgcolor: "rgba(239,108,0,0.14)",
                                                    color: "#ef6c00",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faFilePdf} />
                                            </Box>
                                            <Typography variant="body1" color="#234" fontWeight={600} sx={{ lineHeight: 1.35 }}>
                                                Télécharger le programme municipal VLD 2026 (PDF)
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 4 }}>
                                        <Box sx={{ display: "flex", justifyContent: { xs: "flex-start", sm: "flex-end" } }}>
                                            <Button
                                                component="a"
                                                href="/files/Programme-VLD2026.pdf"
                                                download
                                                size="small"
                                                variant="contained"
                                                sx={{ textTransform: "none", borderRadius: 2, fontWeight: 700 }}
                                            >
                                                Télécharger
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Container maxWidth="lg">



                {/* --- SECTION 1 : PORTRAIT & PARCOURS --- */}
                <Box sx={{ mb: 8 }}>
                    <Grid container spacing={6}>
                        {/* Photo + Identité */}
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Paper elevation={3} sx={{ borderRadius: 4, overflow: "hidden", height: "100%", bgcolor: "#f5f5f5" }}>
                                <Box sx={{ height: 400, overflow: "hidden", position: "relative" }}>
                                    <img
                                        src={candidatePhoto}
                                        alt="Jean-Philippe Guibert"
                                        style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }}
                                    />
                                </Box>
                                <Box sx={{ p: 4, bgcolor: "#f5f5f5" }}>
                                    <Typography variant="h5" fontWeight={700} color="#1565c0" gutterBottom>
                                        Jean-Philippe Guibert
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" paragraph>
                                        Docteur en sciences des matériaux, officier de réserve et photographe passionné.
                                    </Typography>
                                </Box>
                            </Paper>
                        </Grid>

                        {/* Texte Parcours */}
                        <Grid size={{ xs: 12, md: 8 }}>
                            <Box sx={{ mb: 4 }}>
                                <Typography variant="overline" color="#ef6c00" fontWeight={800} letterSpacing={2}>
                                    LE CANDIDAT
                                </Typography>
                                <Typography variant="h4" fontWeight={800} color="#37474f" gutterBottom>
                                    Mon parcours
                                </Typography>
                                <Box sx={{ width: 60, height: 4, bgcolor: "#ef6c00", mb: 3, borderRadius: 2 }} />
                            </Box>

                            <Typography variant="body1" paragraph color="text.secondary" sx={{ fontSize: "1.05rem", lineHeight: 1.7 }}>
                                Je suis docteur en sciences des matériaux. Pendant quelques années, j&apos;ai mis mon savoir-faire au service
                                de notre défense nationale et d&apos;une entreprise travaillant dans la mécanique de précision. J’ai eu la chance
                                de gérer des équipes aux profils variés et d&apos;apprendre la prise de décision sur des sujets aux conséquences
                                souvent majeures.
                            </Typography>
                            <Typography variant="body1" paragraph color="text.secondary" sx={{ fontSize: "1.05rem", lineHeight: 1.7 }}>
                                Parallèlement, j’ai aussi été secrétaire général de l’institut Prospective et sécurité de l’Europe ; un poste
                                que j’ai occupé bénévolement et qui nécessite une vision stratégique, sens de l&apos;organisation et de la rigueur.
                                Je suis aussi officier de réserve.
                            </Typography>
                            <Typography variant="body1" paragraph color="text.secondary" sx={{ fontSize: "1.05rem", lineHeight: 1.7 }}>
                                Il y a 26 ans, avec mon épouse, nous avons choisi de nous installer ici, à Bois-le-Roi, et de changer nos modes
                                de vie. Je me suis alors établi à mon compte comme photographe. Une passion autant qu&apos;un métier qui me permet
                                d’avoir plus de temps libre à consacrer aux autres.
                            </Typography>
                            <Typography variant="body1" color="text.secondary" sx={{ fontSize: "1.05rem", lineHeight: 1.7 }}>
                                Aujourd’hui mes filles sont devenues des jeunes femmes qui font ma fierté, je peux donc sereinement me mettre
                                encore davantage au service de l’intérêt général.
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>

                {/* --- SECTION VALEURS & DEVISE --- */}
                <Box sx={{ mb: 10 }}>
                    <Grid container spacing={4} alignItems="stretch">
                        {/* Colonne Valeurs */}
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Typography variant="h5" fontWeight={800} color="#1565c0" gutterBottom>
                                Mes valeurs
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                Des principes forts qui guident chacune de mes actions pour la commune.
                            </Typography>
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
                                {[
                                    "Honnêteté",
                                    "Indépendance",
                                    "Ouverture d’esprit",
                                    "Empathie",
                                    "Fidélité",
                                    "Sens de l'engagement",
                                    "Intérêt général",
                                ].map((val) => (
                                    <Chip
                                        key={val}
                                        label={val}
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: "0.95rem",
                                            padding: "20px 10px",
                                            borderRadius: 3,
                                            bgcolor: "white",
                                            border: "1px solid rgba(0,0,0,0.08)",
                                            color: "#455a64",
                                            boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
                                            transition: "all 0.2s",
                                            "&:hover": {
                                                bgcolor: "#e3f2fd",
                                                color: "#1565c0",
                                                borderColor: "#1565c0",
                                                transform: "translateY(-2px)",
                                            },
                                        }}
                                    />
                                ))}
                            </Box>
                        </Grid>

                        {/* Colonne Citation */}
                        <Grid size={{ xs: 12, md: 5 }}>
                            <Paper
                                elevation={0}
                                sx={{
                                    height: "100%",
                                    p: 4,
                                    borderRadius: 4,
                                    background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)",
                                    color: "white",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    position: "relative",
                                    overflow: "hidden",
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={faQuoteLeft}
                                    style={{
                                        position: "absolute",
                                        top: -20,
                                        right: -10,
                                        fontSize: "10rem",
                                        opacity: 0.1,
                                        color: "white",
                                    }}
                                />

                                <Typography variant="overline" color="rgba(255,255,255,0.7)" letterSpacing={2} fontWeight={700} sx={{ mb: 2 }}>
                                    MA DEVISE
                                </Typography>
                                <Typography variant="h5" component="p" sx={{ fontStyle: "italic", lineHeight: 1.4, fontWeight: 500, mb: 3 }}>
                                    « On n’a rien donné tant qu’on n’a pas tout donné »
                                </Typography>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Box sx={{ width: 30, height: 2, bgcolor: "#ef6c00" }} />
                                    <Typography variant="subtitle2" fontWeight={700}>
                                        Georges Guynemer
                                    </Typography>
                                </Stack>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>

                {/* --- SECTION 2 : HISTORIQUE & VISION (2 COLONNES) --- */}
                <Grid container spacing={4} sx={{ pt: 8, mb: 8 }}>
                    {/* Colonne Gauche : Mandat Passé */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card elevation={0} sx={{ height: "100%", border: "1px solid #e0e0e0", borderRadius: 4, bgcolor: "#fafafa" }}>
                            <CardContent sx={{ p: 4 }}>
                                <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
                                    <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: "#eceff1", color: "#546e7a" }}>
                                        <FontAwesomeIcon icon={faUserTie} size="lg" />
                                    </Box>
                                    <Typography variant="h5" fontWeight={700} color="#37474f">
                                        Mon mandat d’adjoint
                                    </Typography>
                                </Stack>

                                <Typography variant="body2" paragraph color="text.secondary" sx={{ mb: 2 }}>
                                    J’ai rejoint la liste Unis Pour Bois-le-Roi en 2018. Je connaissais Jean-Pierre Dintilhac ; le nom Dintilhac
                                    m&apos;a rassuré. Mais j’ai rapidement compris que ma présence sur la liste du fils était une erreur : nous ne
                                    partageons aucune vision commune.
                                </Typography>
                                <Typography variant="body2" paragraph color="text.secondary">
                                    J’ai néanmoins été très investi dans ma mission d’adjoint aux affaires scolaires et périscolaires. Le maire ne
                                    s’intéressant pas à ces sujets, j’ai pu travailler suivant mes méthodes : toutes les délibérations sur
                                    l’enfance ont été votées à l’unanimité.
                                </Typography>

                                <Box sx={{ bgcolor: "white", p: 2, borderRadius: 2, border: "1px solid #e0e0e0", mb: 2 }}>
                                    <Typography variant="subtitle2" fontWeight={700} color="#43a047" gutterBottom>
                                        <FontAwesomeIcon icon={faHandshake} style={{ marginRight: 8 }} />
                                        Action Covid-19
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" fontSize="0.9rem">
                                        Durant la crise, nous avons rouvert 10 classes pour 113 élèves (capacité max protocole) au 25 mai 2020.
                                        J&apos;ai démissionné fin 2020, les conditions n&apos;étant plus réunies pour agir sereinement.
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Colonne Droite : Pourquoi 2026 */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card elevation={4} sx={{ height: "100%", borderRadius: 4, bgcolor: "white", position: "relative", overflow: "visible" }}>
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: -15,
                                    right: 30,
                                    bgcolor: "#ef6c00",
                                    color: "white",
                                    px: 2,
                                    py: 0.5,
                                    borderRadius: 10,
                                    fontWeight: 700,
                                    fontSize: "0.8rem",
                                    boxShadow: "0 4px 10px rgba(239, 108, 0, 0.4)",
                                }}
                            >
                                <Typography>AVENIR 2026</Typography>
                            </Box>

                            <CardContent sx={{ p: 4 }}>
                                <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
                                    <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: "#fff3e0", color: "#ef6c00" }}>
                                        <FontAwesomeIcon icon={faCity} size="lg" />
                                    </Box>
                                    <Typography variant="h5" fontWeight={700} color="#37474f">
                                        Pourquoi je suis candidat
                                    </Typography>
                                </Stack>

                                <Typography variant="body2" paragraph color="text.secondary">
                                    En novembre 2021, j’ai alerté et mobilisé pour stopper un projet de densification massive irréversible.
                                    C’est dans ce contexte que j’ai créé l’association <b>Vivre la Démocratie</b> et le groupe « Bois-le-Roi Infos
                                    sans censure » pour libérer la parole.
                                </Typography>

                                <Typography variant="subtitle2" fontWeight={700} color="#d32f2f" gutterBottom sx={{ mt: 3 }}>
                                    Le constat est clair : Bois-le-Roi est en danger.
                                </Typography>
                                <Typography variant="body2" paragraph color="text.secondary">
                                    Finances à la dérive, hausses d’impôts, patrimoine non entretenu... Les élections de 2026 seront décisives.
                                </Typography>

                                <Typography variant="body1" fontWeight={600} color="#1565c0" sx={{ mt: 2, borderTop: "1px dashed #e0e0e0", pt: 2 }}>
                                    Si je m&apos;engage, c&apos;est pour incarner une alternative crédible, portée par une équipe compétente et fidèle à des
                                    valeurs simples : travail, écoute, honnêteté et intérêt général.
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {/* --- SECTION VIDÉO --- */}
                <Box sx={{ mb: 10, textAlign: "center" }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
                        <FontAwesomeIcon icon={faVideo} style={{ color: "#ef6c00", fontSize: "1.5rem", marginRight: "10px" }} />
                        <Typography variant="h4" fontWeight={800} color="#1565c0">
                            Découvrez Jean-Philippe en images
                        </Typography>
                    </Box>
                    <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 700, mx: "auto", mb: 5 }}>
                        Au-delà des mots, apprenez à connaître l&apos;homme, ses convictions profondes et sa vision ambitieuse pour redonner à
                        Bois-le-Roi la place qu&apos;elle mérite.
                    </Typography>

                    <Container maxWidth="md">
                        <Paper
                            elevation={6}
                            sx={{
                                borderRadius: 4,
                                overflow: "hidden",
                                position: "relative",
                                pt: "56.25%",
                                bgcolor: "black",
                                boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
                            }}
                        >
                            <iframe
                                style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }}
                                src="https://www.youtube.com/embed/ZOeUvKMFFfE?si=cmUTlDSfbChzbIm8"
                                title="Présentation Jean-Philippe Guibert"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </Paper>
                    </Container>
                </Box>

                {/* --- TRACTS --- */}
                <Box sx={{ mt: 0, py: 4, borderRadius: 8, px: { xs: 2, md: 6 } }}>
                    <Box sx={{ textAlign: "center", mb: 6 }}>
                        <Typography variant="overline" color="#ef6c00" fontWeight={800} letterSpacing={2}>
                            CAMPAGNE 2026
                        </Typography>
                        <Typography variant="h4" fontWeight={800} color="#1565c0" gutterBottom sx={{ mt: 1 }}>
                            Nos tracts de campagne
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: "auto" }}>
                            Retrouvez les dernières publications et analyses distribuées aux habitants pour comprendre nos actions.
                        </Typography>
                        <Box sx={{ width: 60, height: 4, bgcolor: "#43a047", mx: "auto", mt: 3, borderRadius: 2 }} />
                    </Box>

                    <Grid container spacing={4} justifyContent="center">
                        {tracts2026.map((tract: any) => (
                            <Grid size={{ xs: 12, md: 4 }} key={tract.id}>
                                <Card
                                    elevation={0}
                                    sx={{
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        borderRadius: 4,
                                        border: "1px solid rgba(0,0,0,0.05)",
                                        transition: "all 0.3s ease-in-out",
                                        bgcolor: "white",
                                        position: "relative",
                                        overflow: "hidden",
                                        "&:hover": {
                                            transform: "translateY(-8px)",
                                            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                                            "& .icon-bg": {
                                                opacity: 0.1,
                                                transform: "scale(1.2) rotate(-10deg)",
                                            },
                                        },
                                    }}
                                >
                                    <Box sx={{ height: 8, background: "linear-gradient(90deg, #43a047 0%, #66bb6a 100%)" }} />

                                    <CardContent sx={{ flexGrow: 1, p: 4, position: "relative" }}>
                                        <Chip
                                            label={tract.date}
                                            size="small"
                                            sx={{ bgcolor: "#fff3e0", color: "#ef6c00", fontWeight: 700, mb: 2, borderRadius: 2 }}
                                        />

                                        <Typography variant="h6" fontWeight={800} color="#37474f" sx={{ mb: 2, lineHeight: 1.3 }}>
                                            {tract.title}
                                        </Typography>

                                        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                                            {tract.description}
                                        </Typography>
                                    </CardContent>

                                    <Box sx={{ p: 3, pt: 0 }}>
                                        <Button
                                            component={Link}
                                            to={tract.url}
                                            variant="outlined"
                                            fullWidth
                                            endIcon={<FontAwesomeIcon icon={faArrowRight} />}
                                            sx={{
                                                fontWeight: 700,
                                                borderRadius: 3,
                                                textTransform: "none",
                                                borderColor: "#e0e0e0",
                                                color: "#1565c0",
                                                py: 1,
                                                "&:hover": { borderColor: "#1565c0", bgcolor: "#e3f2fd" },
                                            }}
                                        >
                                            Lire le tract
                                        </Button>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                {/* --- RÉSEAUX SOCIAUX --- */}
                <Box sx={{ mt: 8, mb: 4 }}>
                    <Typography variant="h5" align="center" fontWeight={800} color="#37474f" gutterBottom>
                        Restons connectés
                    </Typography>
                    <Box sx={{ width: 40, height: 4, bgcolor: "#1976d2", mx: "auto", mb: 2, borderRadius: 2 }} />
                    <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 5, maxWidth: 600, mx: "auto" }}>
                        Suivez-nous pour échanger, partager nos actualités et découvrir les coulisses de la campagne en temps réel.
                    </Typography>

                    <Grid container spacing={3} justifyContent="center">
                        {[
                            { name: "Facebook", icon: faFacebook, color: "#1877F2", link: "https://www.facebook.com/democratie.blr/", label: "Rejoindre la communauté" },
                            { name: "X (Twitter)", icon: faXTwitter, color: "#000000", link: "https://x.com/JeanPhi56448637", label: "L'actu en direct" },
                            { name: "Instagram", icon: faInstagram, color: "#E4405F", link: "https://www.instagram.com/vivre_la_democratie_a_blr/", label: "Suivre nos stories" },
                            { name: "YouTube", icon: faYoutube, color: "#FF0000", link: "https://www.youtube.com/channel/UCzY-QlEXExtESHRTxgNII-w", label: "Nos vidéos" },
                        ].map((social) => (
                            <Grid size={{ xs: 6, md: 3 }} key={social.name}>
                                <Paper
                                    component="a"
                                    href={social.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    elevation={0}
                                    sx={{
                                        p: 3,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textDecoration: "none",
                                        border: "1px solid",
                                        borderColor: "divider",
                                        borderRadius: 4,
                                        height: "100%",
                                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                            borderColor: social.color,
                                            boxShadow: `0 10px 20px -10px ${social.color}40`,
                                            "& .social-icon": { color: social.color, transform: "scale(1.1)" },
                                            "& .social-btn": { bgcolor: social.color, color: "white", borderColor: social.color },
                                        },
                                    }}
                                >
                                    <Box className="social-icon" sx={{ fontSize: "2.5rem", color: "text.secondary", mb: 2, transition: "all 0.3s ease" }}>
                                        <FontAwesomeIcon icon={social.icon} />
                                    </Box>

                                    <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ mb: 0.5, fontSize: "1rem" }}>
                                        {social.name}
                                    </Typography>

                                    <Typography variant="caption" color="text.secondary" align="center" sx={{ mb: 2, display: "block" }}>
                                        {social.label}
                                    </Typography>

                                    <Button
                                        className="social-btn"
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                            borderRadius: 10,
                                            textTransform: "none",
                                            color: "text.secondary",
                                            borderColor: "divider",
                                            minWidth: 100,
                                            fontWeight: 600,
                                            fontSize: "0.75rem",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        S&apos;abonner
                                    </Button>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
}
